var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { altText, imgSrc } = options; 
__p+='\n\n<div class="local-widget-photo-item js-local-fsgallery-toggle">\n    ';
 if (typeof altText === 'string' && altText) { 
__p+='\n        <img class="img-responsive" src="'+
((__t=( imgSrc ))==null?'':__t)+
'" alt="'+
((__t=( altText ))==null?'':__t)+
'" title="'+
((__t=( altText ))==null?'':__t)+
'">\n    ';
 } else { 
__p+='\n        <img class="img-responsive" src="'+
((__t=( imgSrc ))==null?'':__t)+
'">\n    ';
 } 
__p+='\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./local/templates/community_widget.jst.ejs